import { CheckPermission, Permission } from '@/features/auth'
import { Feedbacks } from '@/features/feedback'

function FeedbacksList() {
  return (
    <CheckPermission
      permissions={[Permission.FEEDBACK_READ]}
      redirect="/goodies"
    >
      <Feedbacks />
    </CheckPermission>
  )
}

export default FeedbacksList
